import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import trusted from '~/assets/img/footer/picto-trustedShops.png';
export default {
  name: 'TrustedShops',
  data: function data() {
    return {
      trusted: trusted
    };
  }
};